import * as React from "react";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { DistributionDividendPreference } from "../../../../../../../../Wrap/Constants/Enums/Domain/DistributionDividendPreference";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { MoneyOrPercentageType } from "../../../../../../../../Wrap/Constants/Enums/MoneyOrPercentageType";
import { InstrumentSelection } from "../../../../../../../../Wrap/Models/Models/InstrumentSelection/InstrumentSelection";
import { InstrumentSelections } from "../../../../../../../../Wrap/Models/Models/InstrumentSelection/InstrumentSelections";
import { QuoteModel } from "../../../../../../../../Wrap/Models/Models/Processes/Quote/QuoteModel";
import {
    getISTPaymentAmount,
    initPensionInstrumentSelections,
    initWeighting,
} from "../../../../../../../Shared/IST/Components/Shared/Utils";
import { InvestmentSelectionTool as IST } from "../../../../../../../Shared/IST/InvestmentSelectionTool";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { AdviserContextStoreStatic } from "../../../../NewBusinessWizard/Stores/Variable";

interface IInvestmentSelectionToolProps extends IProcessComponentProps {
    data: QuoteModel;
}

interface IInvestmentSelectionToolState {}

export class InvestmentSelectionTool extends ProcessComponent<
    IInvestmentSelectionToolProps,
    IInvestmentSelectionToolState
> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private onInvestmentChanges = (changes) => {
        const preRetirement = changes.Instruments.map((ele) => ({
            Instrument: ele.Instrument,
            Single: ele.Single,
            Regular: ele.Regular,
            Transfer: ele.Transfer,
            isToogle: ele.isToogle,
            needToggle: ele.needToggle,
            isTargetAllocation: ele.isTargetAllocation,
            underlying: ele.underlying,
            modelPortfolioType: ele.modelPortfolioType,
            ClientRegular: ele.ClientRegular,
            EmployerRegular: ele.EmployerRegular,
            ThirdPartyRegular: ele.ThirdPartyRegular,
            EmployerSalaryDeductionRegular: ele.EmployerSalaryDeductionRegular,
        }));
        const postRetirement = changes.Instruments.map((ele) => ({
            Instrument: ele.Instrument,
            Transfer: ele.PostTransfer || null,
            Single: initWeighting(),
            Regular: initWeighting(),
        }));
        this.onDataChange(
            this.props.onChange,
            {
                PreRetirementInstrumentSelections: this.initInstrumentSelection(preRetirement),
                PostRetirementInstrumentSelections: this.initInstrumentSelection(postRetirement),
            },
            this.props.data,
            "PensionQuote"
        );
    };

    private initInstrumentSelection = (instruments: InstrumentSelection[]): InstrumentSelections => {
        return {
            Type: MoneyOrPercentageType.Percentage,
            Instruments: instruments,
            DistributionDividendPreference: DistributionDividendPreference.NotSpecified,
        };
    };

    public render(): JSX.Element {
        const { data, orderType, onOrderTypeChange } = this.props;
        const paymentAmount = getISTPaymentAmount(data?.PensionQuote, "PensionTransfers");

        const modelData = JSON.parse(JSON.stringify(data?.PensionQuote));
        modelData.CashInstrument = data.CashInstrument;
        modelData.OwnerHierarchyId = data.OwnerHierarchyId;

        const preRetirement = data?.PensionQuote?.PreRetirementInstrumentSelections?.Instruments || [];
        const postRetirement = data?.PensionQuote?.PostRetirementInstrumentSelections?.Instruments || [];
        const instrumentSelection = this.initInstrumentSelection([]);
        instrumentSelection.Instruments = initPensionInstrumentSelections(preRetirement, postRetirement);
        const clAccountId = new URLSearchParams(window.location.search).get("clAccountId");
        const adviser = AdviserContextStoreStatic.getData();

        return (
            <div>
                <h2 className="mb-20">Investment selection</h2>
                <IST
                    withReRegistrationTransferIn={false}
                    data={instrumentSelection}
                    modelData={modelData}
                    onRef={(ref) => this.appendChild(ref)}
                    onChange={(changes) => {
                        if (changes.orderType) {
                            onOrderTypeChange(changes.orderType);
                        } else {
                            this.onInvestmentChanges(changes)
                        }
                    }}
                    showErrorMsgPopUp={(msg) => this.props.showErrorMsgPopUp(msg)}
                    type={ProcessType.Quote}
                    hiercharyId={data?.PensionQuote?.HierarchyId}
                    headAccountHierarchyId={data.ExistingAccountHierarchyId}
                    companyCode={adviser?.Company}
                    claccountId={clAccountId}
                    product={SubAccountType.JuniorSipp}
                    paymentAmount={{ Amount: paymentAmount, Currency: CurrencyCode.GBP }}
                    bankAccounts={[]}
                    onBankChange={() => {}}
                    onDistributionDividendOptions={() => {}}
                    decisionMakerHierarchyId={data?.PensionQuote?.HierarchyId}
                    accountAdviceType={data?.AccountAdviceType}
                    accountServiceProposition={data?.AccountServiceProposition}
                    onDecisionMakerChange={(v) => this.onDataChange(this.props.onChange, v, data, "PensionQuote")}
                    orderType={orderType}
                />
            </div>
        );
    }
}
